import * as Sentry from '@sentry/browser';

/* eslint no-console: 0 */
const devLoger = {
  info: console.log,
  warn: console.warn,
  error: console.error
};

const noop = () => {};

const prodLoger = {
  info: noop,
  warn: message => Sentry.captureMessage(message, 'warning'),
  error: message => Sentry.captureMessage(message, 'error')
};

export const log = process.env.NODE_ENV === 'development' ? devLoger : prodLoger;
